<template>
  <d2-container>
    <div class="login-container">
      <div class="loginbasecont">
        <div class="logincontLft">
          <div class="logincontCon1">让我们一起开启智能未来</div>
          <div class="logincontCon3">加入算力城市大家庭，携手共创智能新世界</div>
        </div>

        <el-card class="box-card">
          <template>
            <div class="card-header">
              <span>欢迎注册</span>
            </div>
          </template>

          

          <el-form :model="form" status-icon :rules="rules" ref="ruleForm" style="margin: 0px 30px;">
            <el-form-item prop="username">
              <el-input v-model="form.username" placeholder="用户名" autocomplete="off" ref="username"  @input="clearErrors"/>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="密码" show-password
                        autocomplete="off" ref="password"  @input="clearErrors"/>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input type="phone" v-model="form.phone" placeholder="手机号" autocomplete="off" ref="phone"  @input="clearErrors"/>
            </el-form-item>
            <el-form-item prop="verification_code">
              <el-input class="verification_codeWidth" type="verification_code" 
                  v-model="form.verification_code" 
                  placeholder="请输入验证码"
                  autocomplete="off" ref="verification_code"
                   @input="clearErrors"
              />
              <el-button type="primary" size="medium" round id="send-code-btn"
                         :disabled="isCounting || isSendCodeDisabled">
                         <!--@click="sentVeriCode" >-->
                <span style="color:#fff;">{{ buttonMessage }}</span>
              </el-button>
            </el-form-item>
            <div id="captcha-element" style="height: 0;"></div>
            <el-form-item prop="email">
              <el-input type="email" v-model="form.email" placeholder="邮箱" autocomplete="off"  @input="clearErrors"/>
            </el-form-item>

            <!--
            <el-form-item prop="description" v-if="false">
              <el-input type="description" v-model="form.description" placeholder="请输入备注信息"
                        autocomplete="off"/>
            </el-form-item>
            <el-form-item prop="displayname" v-if="false">
              <el-input type="displayname" v-model="form.displayname" placeholder="请输入显示名称"
                        autocomplete="off"/>
            </el-form-item>
            <el-form-item prop="real_name" v-if="false">
              <el-input type="real_name" v-model="form.real_name" placeholder="请输入真实姓名"
                        autocomplete="off"/>
            </el-form-item>
            <el-form-item prop="id_number" v-if="false">
              <el-input type="id_number" v-model="form.id_number" placeholder="请输入身份证号"
                        autocomplete="off"/>
            </el-form-item>
            <el-form-item prop="address" v-if="false">
              <el-input type="address" v-model="form.address" placeholder="请输入地址" autocomplete="off"/>
            </el-form-item>
            -->
            <el-form-item class="agreement-text">
              <el-checkbox v-model="form.agree" name="agree">
                我已阅读并同意
                <a href="javascript:void(0)" @click="showServiceAgreement">《平台服务协议》</a>和
                <a href="javascript:void(0)" @click="showPrivacyAgreement">《隐私政策》</a>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" round class="login-btn" :disabled="isRegisterDisabled"
                         @click="submitForm('ruleForm')"
                         style="width: 100%;">
                <span>注册</span>
              </el-button>
            </el-form-item>
          </el-form>
          <!-- 错误信息列表（显示在表单上方或下方） -->
          <div v-if="errorMessageList.length > 0" class="error-message-box">
            <el-alert
              v-for="(error, index) in errorMessageList"
              :key="index"
              :title="error"
              type="error"
              show-icon
              :closable="true"
              class="error-item"
            />
          </div>
        </el-card>
      </div>
      <div class="filing-info">
        <p><a href="https://beian.mps.gov.cn/#/query/webSearch?code=65222302000015" rel="noreferrer" target="_blank">新公网安备65222302000015号 </a> <a href="http://beian.miit.gov.cn/" target="_blank"> 新ICP备2024016726号-1</a></p>
      </div>
    </div>
  </d2-container>
</template>

<script>
import {aesEncrypt} from '@/utils/crypto'

let debug = false

export default {
  name: 'hosting',
  data() {
    return {
      form: {
        username: '',
        password: '',
        phone: '',
        verification_code: '',
        description: '',
        displayname: '',
        real_name: '',
        id_number: '',
        email: '',
        address: '',
        agree: false,
      },
      errorMessageList: [], // 用于存储错误信息列表
      nextErrorId: 1, // 用于生成唯一的错误信息ID

      countDown: 60, // 验证码的倒计时
      isCounting: false,
      timer: null,

      // bSentCodeSuccess: false,
      captchaVerifyResult: false,

      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, message: '用户名长度不能小于3个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: this.validatePassword, trigger: ['blur', 'change']}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: this.validatePhone, trigger: ['blur', 'change']}
        ],
        // verification_code: [
        //   {required: true, message: '请输入6位验证码', trigger: 'blur'},
        //   {validator: this.validateCode, trigger: ['blur', 'change']}
        // ]
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.clearErrors()
      },
      deep: true // 深度监听 form 所有字段
    }
  },
  computed: {
    isRegisterDisabled () {
      return !this.form.agree || !this.form.username || !this.form.password || !this.isValidPhone(this.form.phone)
          || !this.isValidCode(this.form.verification_code)

    },
    isSendCodeDisabled () {
      return !this.isValidPhone(this.form.phone)
    },
    buttonMessage () {
      return this.isCounting ? `${this.countDown} 秒` : '获取验证码';
    }
  },
  created () {
    // 初始化阿里云验证码
    initAliyunCaptcha({
      SceneId: '18fd1xsb', // 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: '1g25jr', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'popup', // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#send-code-btn', // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      immediate: false, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
      region: 'cn' //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
    });
  },
  mounted () {
    console.log("### [mounted]")
  },
  methods: {
    /******************************************************************************************/
    // 阿里云captchar验证（验证真人操作）相关
    async captchaVerifyCallback (captchaVerifyParam) {
      // console.log('# captchaVerifyCallback - entry', captchaVerifyParam)
      console.log('# captchaVerifyCallback - entry')
      // this.bSentCodeSuccess = false
      if (!this.form.phone) {
        this.$message.error({
          message: '请输入手机号',
          center: true // 居中显示
        })
        this.$refs.phone.focus()
        return
      }

      const response = await this.$axios.post('/api/captcha', {captchaVerifyParam: captchaVerifyParam})
      console.log(response)
      if (response.data && response.code === 200) {
        this.captchaVerifyResult = response.data.captchaVerifyResult
      } else {
        this.$message.error({
          message: response.msg,
          center: true // 居中显示
        })
      }

      return {
        captchaResult: this.captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
        bizResult: true, // 业务验证是否通过，boolean类型，可选，若为无业务验证结果的场景，bizResult可以为空
      }
    },

    async onBizResultCallback (bizResult) {
      console.log('# onBizResultCallback - entry', this.captchaVerifyResult, bizResult)
      await this.sentVeriCode()
      console.log('# onBizResultCallback - return')
    },

    getInstance (instance) {
      console.log('# getInstance - return', instance)
    },

    /*****************************************************************************************/
    // 发送验证码
    async sentVeriCode() {
      if (!debug) {
        const phone = this.form.phone
        const response = await this.$axios.post('/api/send_code', {'phone': phone})
        console.log(response)
        if (response.data && response.code === 200) {
          this.$message.success({
            message: response.msg,
            center: true // 居中显示
          });
        } else {
          this.$message.error({
            message: response.msg,
            center: true // 居中显示
          })
        }
      }
      this.bSentCodeSuccess = true

      // 开始倒计时
      this.isCounting = true
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        } else {
          clearInterval(this.timer)
          this.isCounting = false
          this.countDown = 60 // 重置计数器
        }
      }, 1000)
    },

    /*****************************************************************************************/

    // 清除所有错误提示
      clearErrors() {
        this.errorMessageList = []
      },

      // 手动关闭某条错误（可选）
      removeError(id) {
        this.errorMessageList = this.errorMessageList.filter(err => err.id !== id)
      },

    // 提交表单、创建用户
    submitForm(formName) {
       // ✅ 提交前先清空旧错误
      this.clearErrors()

      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('[submitForm]: Start!')
          const pwCode = aesEncrypt(this.form.password)
          const self = this; // 保存当前的 this 引用
          this.$axios({
            method: 'post',
            url: '/api/create_user',
            data: {
              name: this.form.username,
              password: pwCode,
              phone: this.form.phone,
              verification_code: this.form.verification_code,
              real_name: this.form.real_name,
              id_number: this.form.id_number,
              description: this.form.description,
              displayname: this.form.displayname,
              address: this.form.address,
            }
          }).then(res => {
            console.log(res); // 检查响应
            self.$router.push({name: 'registerSuccess'}) // 使用保存的 this 引用
          }).catch(error => {
          // 清空上一次的错误
          this.errorMessageList = []

          let msg = '请求失败，请稍后重试'

          if (error.response) {
            // 服务器返回错误
            msg = error.response.data.msg || msg
          } else if (error.request) {
            // 网络错误
            msg = '网络连接失败，请检查网络'
          } else {
            // 其他错误
            msg = '请求发送失败，请稍后重试'
          }

          // 添加错误信息到列表
          this.errorMessageList.push(msg)

          this.errorMessageList = [];
          // DOM 更新后，尝试聚焦到对应输入框
          this.$nextTick(() => {
            if (msg.includes('用户名') && this.$refs.username) {
              this.$refs.username.focus()
            } else if (msg.includes('密码') && this.$refs.password) {
              this.$refs.password.focus()
            } else if (msg.includes('手机号') && this.$refs.phone) {
              this.$refs.phone.focus()
            } else if (msg.includes('验证码') && this.$refs.verification_code) {
              this.$refs.verification_code.focus()
            } else if (msg.includes('姓名') && this.$refs.real_name) {
              this.$refs.real_name.focus()
            } else if (msg.includes('身份证') && this.$refs.id_number) {
              this.$refs.id_number.focus()
            } else if (msg.includes('描述') && this.$refs.description) {
              this.$refs.description.focus()
            } else if (msg.includes('地址') && this.$refs.address) {
              this.$refs.address.focus()
            }
            this.errorMessageList.push(msg) // 再添加
          })
        })
    } else {
      console.log('表单验证失败！');
      return false;
    }
  });
    },

    // 验证手机号是否正确
    validatePhone(rule, value, callback) {
      if (!this.isValidPhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    },
    isValidPhone(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(phone)
    },

    // 验证验证码是否正确
    validateCode (rule, value, callback) {
      const codeRegex = /^\d{6}$/;
      if (!this.isValidCode(value)) {
        callback(new Error('请输入6位数字验证码'));
      } else {
        callback();
      }
    },
    isValidCode (value) {
      const codeRegex = /^\d{6}$/;
      return codeRegex.test(value);
    },

    // 验证密码是否正确
    validatePassword(rule, value, callback) {
      // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;
      const passwordRegex = /.{6,}$/;
      if (!passwordRegex.test(value)) {
        // callback(new Error('密码必须包含至少一个大写字母、一个小写字母和一个数字，并且长度至少为6个字符'));
        callback(new Error('密码长度至少为6个字符'))
      } else {
        callback();
      }
    },

    // 显示服务协议
    showServiceAgreement() {
      window.open('https://docs.ltaidc.com/term-of-service.html', '_blank');
    },

    // 显示隐私协议
    showPrivacyAgreement() {
      window.open('https://docs.ltaidc.com/privacy.html', '_blank');
    },

  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }

  },

}
</script>

<style scoped>

@media (min-width: 769px) {
  /* PC端样式 */
.filing-info {
  margin-top: 25px;
  margin-bottom: 8px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: baseline;
}
.filing-info a {
  color: #7F7F7F;
  font-size: 12px;
  text-decoration: none;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  background: url(/image/portalimg/loginin.png) no-repeat;
  background-size: 100% 100%;
}

.loginbasecont {
  width: 1560px;
  height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logincontLft {
  width: 766px;
  float: left;
  margin-right: 200px;
}

.logincontCon1 {
  font-size: 48px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 500;
  margin-bottom: 32px;
}

.logincontCon3 {
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 400;
}

.box-card {
  width: 450px;
  height: 640px;
  float: right;

}

.card-header {
  text-align: center;
  padding: 40px 0;
}

.card-header span {
  font-size: 24px;
  color: #000000;
  letter-spacing: 4px;
  font-weight: 600;
}

.login-btn {
  color: #fff !important;
}

.login-btn span {
  color: #fff !important;
}

.verification_codeWidth{
  width: 225px;
}
  #send-code-btn{
    margin-left: 10px; 
    width: 115px; 
    color: #fff !important;
    float:right;
  }


}

@media (max-width: 768px) {
  /* 移动端样式 */
  .filing-info {
  margin-top: 25px;
  margin-bottom: 8px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: baseline;
}
.filing-info a {
  color: #7F7F7F;
  font-size: 10px;
  text-decoration: none;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  background: url(/image/portalimg/loginin.png) no-repeat;
  background-size: 100% 100%;
}

.loginbasecont {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  overflow: hidden;
}

.logincontLft {
  width: 100%;
}

.logincontCon1 {
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2px;
  font-weight: 600;
  text-align: center;
  margin-top: 86px;
}

.logincontCon3 {
  font-size: 12px;
  color: #05004B;
  letter-spacing: 2px;
  font-weight: 400;
  margin-top: 13px;
  margin-bottom: 30px;
  text-align: center;
}
.el-card__body, .el-main {
  padding:10px;
}
.box-card {
  width: 100%;
  height:80%;
  overflow-y: scroll;
}
  /* 当视口高度小于等于600px时 */
  @media (max-height: 670px) {
      .box-card {
          height: 70%; /* 调整高度以适应小屏幕 */
      }
  }

  /* 当视口高度大于600px且小于等于800px时 */
  @media (min-height: 671px) and (max-height: 900px) {
      .box-card {
          height:80vh; /* 中等高度 */
      }
  }

  /* 当视口高度大于800px时 */
  @media (min-height: 901px) {
      .box-card {
          height: 90vh; /* 较大高度 */
      }
  }

.card-header {
  text-align: center;
  padding: 40px 0;
}

.card-header span {
  font-size: 24px;
  color: #000000;
  letter-spacing: 4px;
  font-weight: 600;
}

.login-btn {
  color: #fff !important;
}

  .login-btn span {
    color: #fff !important;
  }
  .loginbasecont{
    width: 100%;
  }
  .verification_codeWidth{
    width: 54%;
  }
  .agreement-text .el-checkbox__label{
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 10px !important;
  }
  #send-code-btn{
    margin-left: 10px; 
    width: 42%; 
    color: #fff !important;
    float:right;
  }
}
.error-message-box {
  margin-bottom: 20px;
}

.error-item {
  margin-bottom: 8px;
}

/* 让 el-form-item 的 ref 能正确获取 */
.el-form-item {
  margin-bottom: 20px;
}
</style>
